<template>
    <div>
        <HelloWorld :loginFlag="loginFlag" :userName="userName"></HelloWorld>
        <!-- 页首 -->
        <div style="width: 100%; background: radial-gradient(rgba(255, 154, 129, 0.3),#ffffff);">
            <div style="padding-top: 100px; width: 75%; margin: 0px auto; padding-bottom: 100px;">
                <h2>XUS数字商城 用1分成本，撬动10倍回报</h2>
                <div style="font-size: 14px; font-weight: bold; margin-top: 20px;">
                    XUS数字商城——不止是系统，更是您的24小时智能生意伙伴
                </div>
                <div style="margin-top: 15px; font-size: 13px; color: #767676;">
                    <span style="font-weight: bold; margin-top: 15px;">「别人卖系统，我们给答案」</span><br />
                    比“专业”更懂创业：专为小微企业和个体创业者定制，0代码操作，3分钟建站。<br />
                    比“高效”更极致：智能客服响应，运营效率提升70%。<br />
                    比“稳定”更可靠：VUE + JAVA前后端分离更加可靠高效。<br />
                    <div style="margin-top: 45px;">
                        <div style="color: #ffffff; background-color: black; float: left; padding-top: 5px; padding-bottom: 5px; padding-left: 8px; padding-right: 8px; border-radius: 10px; font-size: 16px; cursor: pointer;" @click="purchase(-1)">立刻购买</div>
                        <div style="color: #000000; border: 1px solid black; float: left; padding-top: 5px; padding-bottom: 5px; padding-left: 8px; padding-right: 8px; border-radius: 10px; font-size: 16px; margin-left: 30px; cursor: pointer;" @click="goToDocumentation()">部署文档</div>
                        <div v-if="statusPC == '1'" style="color: #000000; border: 1px solid black; float: left; padding-top: 5px; padding-bottom: 5px; padding-left: 8px; padding-right: 8px; border-radius: 10px; font-size: 16px; margin-left: 30px; cursor: pointer;">联系我们</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 产品亮点 -->
        <h1 style="text-align: center; margin-top: 30px;">*产品亮点*</h1>
        <div style="width: 80%; margin: 0px auto;">
            <el-row :gutter="12">
                <el-col :span="8" v-for="(item, index) in textCard" :key="index" style=" margin-top: 20px;">
                    <el-card shadow="hover" style="height: 150px; border-radius: 10px;">
                        <h3 style="span-align: center;">{{ item.biaot }}</h3>
                        <div style="margin-top: 20px; color: #767676;">
                            <span style="margin-top: 20px;">{{ item.text }}</span>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>

        <!-- 功能-定价 -->
        <h1 style="text-align: center; margin-top: 30px;">*功能-定价*</h1>
        <div style="width: 80%; margin: 0px auto; padding-bottom: 30px;">
            <table :border="true" style="border-radius: 10px; border: 1px solid #d1d1d1; margin-top: 20px; width: 100%; border-collapse:collapse;">
                <tr style="background-color: #d1d1d1;">
                    <th style="color: #000000; font-size: 16px;" colspan="2" align="center">功能</th>
                    <th align="center" style="color: #000000;">
                        <div style="font-size: 16px; margin-top: 15px; margin-bottom: 10px;">
                            <span>创业版<br /></span>
                            <div style="margin-top: 5px;">
                                <span style="font-size: 16px;">
                                    <span style="font-size: 20px;">￥</span>
                                    69 / 年
                                </span>
                            </div>
                            <div class="chuangyeb" @click="purchase(1)">立即购买</div>
                        </div>
                    </th>
                    <th align="center" style="color: #000000;">
                        <div style="font-size: 16px;">
                            <span>专业版<br /></span>
                            <div style="margin-top: 5px;">
                                <span style="font-size: 16px;">
                                    <span style="font-size: 20px;">￥</span>
                                    199 / 年
                                </span>
                            </div>
                            <div class="lijigoumaiT">立即购买</div>
                        </div>
                    </th>
                    <th align="center" style="color: #000000;">
                        <div style="font-size: 16px;">
                            <span>高级版<br /></span>
                            <div style="margin-top: 5px;">
                                <span style="font-size: 16px;">
                                    <span style="font-size: 20px;">￥</span>
                                    399 / 年
                                </span>
                            </div>
                            <div class="lijigoumaiT">立即购买</div>
                        </div>
                    </th>
                </tr>
                <tr style="height: 60px;">
                    <td rowspan="4" align="center">客户端</td>
                    <td align="center">PC网站</td>
                    <td align="center">
                        <div>
                            <i class="el-icon-success" style="font-size: 30px; color: #47d600;"></i>
                        </div>
                    </td>
                    <td align="center">
                        <div>
                            <i class="el-icon-success" style="font-size: 30px; color: #47d600;"></i>
                        </div>
                    </td>
                    <td align="center">
                        <div>
                            <i class="el-icon-success" style="font-size: 30px; color: #47d600;"></i>
                        </div>
                    </td>
                </tr>
                <tr style="height: 60px;">
                    <td align="center">移动端网站</td>
                    <td align="center">
                        <div>
                            <i class="el-icon-success" style="font-size: 30px; color: #47d600;"></i>
                        </div>
                    </td>
                    <td align="center">
                        <div>
                            <i class="el-icon-success" style="font-size: 30px; color: #47d600;"></i>
                        </div>
                    </td>
                    <td align="center">
                        <div>
                            <i class="el-icon-success" style="font-size: 30px; color: #47d600;"></i>
                        </div>
                    </td>
                </tr>
                <tr style="height: 60px;">
                    <td align="center">App</td>
                    <td align="center">
                        <div>
                            按需购买
                        </div>
                    </td>
                    <td align="center">
                        <div>
                            按需购买
                        </div>
                    </td>
                    <td align="center">
                        <div>
                            按需购买
                        </div>
                    </td>
                </tr>
                <tr style="height: 60px;">
                    <td align="center">微信小程序</td>
                    <td align="center">
                        <div>
                            按需购买
                        </div>
                    </td>
                    <td align="center">
                        <div>
                            按需购买
                        </div>
                    </td>
                    <td align="center">
                        <div>
                            按需购买
                        </div>
                    </td>
                </tr>

                <tr style="height: 60px;">
                    <td rowspan="2" align="center">管理端</td>
                    <td align="center">PC网站</td>
                    <td align="center">
                        <div>
                            <i class="el-icon-success" style="font-size: 30px; color: #47d600;"></i>
                        </div>
                    </td>
                    <td align="center">
                        <div>
                            <i class="el-icon-success" style="font-size: 30px; color: #47d600;"></i>
                        </div>
                    </td>
                    <td align="center">
                        <div>
                            <i class="el-icon-success" style="font-size: 30px; color: #47d600;"></i>
                        </div>
                    </td>
                </tr>
                <tr style="height: 60px;">
                    <td align="center">移动端网站</td>
                    <td align="center">
                        <div>
                            <i class="el-icon-success" style="font-size: 30px; color: #47d600;"></i>
                        </div>
                    </td>
                    <td align="center">
                        <div>
                            <i class="el-icon-success" style="font-size: 30px; color: #47d600;"></i>
                        </div>
                    </td>
                    <td align="center">
                        <div>
                            <i class="el-icon-success" style="font-size: 30px; color: #47d600;"></i>
                        </div>
                    </td>
                </tr>

                <tr style="height: 60px;">
                    <td rowspan="4" align="center">商品功能</td>
                    <td align="center">虚拟商品</td>
                    <td align="center">
                        <div>
                            <i class="el-icon-success" style="font-size: 30px; color: #47d600;"></i>
                        </div>
                    </td>
                    <td align="center">
                        <div>
                            <i class="el-icon-success" style="font-size: 30px; color: #47d600;"></i>
                        </div>
                    </td>
                    <td align="center">
                        <div>
                            <i class="el-icon-success" style="font-size: 30px; color: #47d600;"></i>
                        </div>
                    </td>
                </tr>
                <tr style="height: 60px;">
                    <td align="center">卡密商品</td>
                    <td align="center">
                        <div>
                            <i class="el-icon-success" style="font-size: 30px; color: #47d600;"></i>
                        </div>
                    </td>
                    <td align="center">
                        <div>
                            <i class="el-icon-success" style="font-size: 30px; color: #47d600;"></i>
                        </div>
                    </td>
                    <td align="center">
                        <div>
                            <i class="el-icon-success" style="font-size: 30px; color: #47d600;"></i>
                        </div>
                    </td>
                </tr>
                <tr style="height: 60px;">
                    <td align="center">直冲商品</td>
                    <td align="center">
                        <div>
                            <i class="el-icon-success" style="font-size: 30px; color: #47d600;"></i>
                        </div>
                    </td>
                    <td align="center">
                        <div>
                            <i class="el-icon-success" style="font-size: 30px; color: #47d600;"></i>
                        </div>
                    </td>
                    <td align="center">
                        <div>
                            <i class="el-icon-success" style="font-size: 30px; color: #47d600;"></i>
                        </div>
                    </td>
                </tr>
                <tr style="height: 60px;">
                    <td align="center">实体商品</td>
                    <td align="center">
                        <div>
                            <i class="el-icon-error" style="font-size: 30px; color: #d60000;"></i>
                        </div>
                    </td>
                    <td align="center">
                        <div>
                            <i class="el-icon-success" style="font-size: 30px; color: #47d600;"></i>
                        </div>
                    </td>
                    <td align="center">
                        <div>
                            <i class="el-icon-success" style="font-size: 30px; color: #47d600;"></i>
                        </div>
                    </td>
                </tr>
            </table>
        </div>

        <!-- 购买弹窗 -->
        <el-dialog title="提示" :visible.sync="dialogVisible" width="80%">
            <el-form ref="form" :model="zPay" label-width="80px">
                <el-form-item label="域名">
                    <el-input v-model="zPay.url" placeholder="无域名填写ip即可"></el-input>
                </el-form-item>
                <el-form-item label="服务器ip" placeholder="服务器ip">
                    <el-input v-model="zPay.userIp"></el-input>
                </el-form-item>
                <el-form-item label="特殊资源">
                    <el-radio-group v-model="zPay.subject">
                        <el-radio label="创业板"></el-radio>
                        <el-radio label="专业版"></el-radio>
                        <el-radio label="高级版"></el-radio>
                        <el-radio label="企业版"></el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div style="color: #999999; text-align: center;">如用户更换服务器, 请在订单中更新自己的服务器ip, 避免无法更新以及无法维护问题。<span style="color: red;">客户不换ip出现任何问题官方不受理</span></div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="createOrder()">确 定</el-button>
            </span>
        </el-dialog>
        <div v-html="payForm" ref="payFormContainer" style="display:none;"></div>
    </div>
</template>

<script>
    import axios from 'axios';
    // 设置 Axios 默认配置
    axios.defaults.baseURL = 'https://api.ixushan.com'; // 后端地址
    axios.defaults.headers.post['Content-Type'] = 'application/json';
    import HelloWorld from '@/components/top-bar.vue'
    export default {
        components: {
            HelloWorld
        },
        data() {
            return {
                // 服务端状态
                statusPC: sessionStorage.getItem("statusPC"),
                loginFlag: '',
                userName: '',
                textCard: [{
                        biaot: '一键安装',
                        text: '像安装软件一样简单的一键式部署，无需会技术最快三分钟即可开始运营商城网站'
                    },
                    {
                        biaot: '门槛极低',
                        text: '服务器门槛和使用门槛都极低，服务器最低可支持1*1服务器，使用方法在管理端中有操作文档，降低服务器开销，帮助客户低成本高回报'
                    },
                    {
                        biaot: '官方维护',
                        text: '如果服务器出现问题，可以找到客服进行上报，我们将第一时间对您的服务器进行维护，避免给您造成不必要的损失'
                    },
                    {
                        biaot: '及时响应',
                        text: '用户发现问题后可来官网或找到客服提交bug或者优化方案，我们将第一时间进行采纳，三个月内会将用户的优化方案更新到所有用户的手中'
                    },
                    {
                        biaot: '定制开发',
                        text: '行业深耕,团队可靠,多年技术沉淀，欢迎用户前来定制开发，旭杉可开发APP、微信小程序、WEB网站，价格低廉'
                    },
                    {
                        biaot: '智能AI客服',
                        text: 'XUS商城全面接入DeepSeek，让客户解决双手，彻底的脱机式管理，让用户们能够坐在家里数钱'
                    }
                ],
                // 购买弹窗状态
                dialogVisible: false,

                zPay: {
                    userId: '',
                    subject: '',
                    url: '',
                    userIp: ''
                },

                payForm: '' // 存储支付宝返回的支付表单

            }
        },
        mounted() {
            this.loginFlag = !localStorage.getItem('userTK') == ''
            this.userName = localStorage.getItem('userName')
        },
        methods: {
            // 跳转到文档
            goToDocumentation() {
                this.$router.push('/documentation')
            },

            // 购买功能
            purchase(status) {
                this.zPay.userId = localStorage.getItem('userId')
                if (this.zPay.userId == null || this.zPay.userId == '') {
                    this.$router.push('/login')
                    return
                }
                this.dialogVisible = true
                switch (status) {
                    case 1:
                        this.zPay.subject = '创业版'
                        break;
                }
            },

            async createOrder() {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    const response = await axios.post('/alipay/createOrder', this.zPay);

                    // 检查返回的数据
                    if (!response.data) {
                        throw new Error('后端返回的数据为空');
                    }

                    // 移除 <script> 标签
                    const formHtml = response.data.replace(/<script>.*<\/script>/, '');
                    this.payForm = formHtml; // 获取支付表单

                    // 确保 DOM 更新完成
                    this.$nextTick(() => {
                        const form = this.$refs.payFormContainer.querySelector('form');
                        if (form) {
                            form.submit(); // 提交表单
                        } else {
                            console.error('未找到支付表单');
                        }
                    });
                } catch (error) {
                    console.error('支付失败:', error);
                }
            }
        }
    }
</script>

<style>
    .container {
        width: 95%;
        height: 60px;
    }

    .fixed-top {
        position: fixed;
        top: 0;
        width: 100%;
        background-color: #ffffff;
        z-index: 999;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .title {
        color: #000000;
    }

    .chuangyeb {
        font-size: 14px;
        font-weight: 300;
        margin-top: 5px;
        background: radial-gradient(rgba(255, 79, 35, 1.0), rgba(255, 190, 133, 1.0));
        padding-top: 5px;
        padding-bottom: 5px;
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 10px;
        color: #ffffff;
        width: 40%;
    }

    .lijigoumaiT {
        font-size: 14px;
        font-weight: 300;
        margin-top: 5px;
        border: 1px solid black;
        padding-top: 5px;
        padding-bottom: 5px;
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 10px;
        color: #000000;
        background-color: #ffffff;
        width: 40%;
    }
</style>